import {
  AcceptorBranchResponsePayload,
  AcceptorCategoryResponsePayload,
  AcceptorResponsePayload,
} from '../../../shared/models/api';
import {createSlice, PayloadAction, SliceCaseReducers} from '@reduxjs/toolkit';
import {AppActions} from '../../actions';

export interface AcceptorsState {
  list: AcceptorResponsePayload[] | null;
  listAcceptorCategories: AcceptorCategoryResponsePayload[] | null;
  acceptorBranches: AcceptorBranchResponsePayload[] | null;
}

const initialState: AcceptorsState = {
  list: null,
  listAcceptorCategories: null,
  acceptorBranches: null,
};

export const acceptorsSlice = createSlice<AcceptorsState, SliceCaseReducers<AcceptorsState>>({
  name: '@@eskso/acceptors',
  initialState,
  reducers: {
    setAcceptors: (state, action: PayloadAction<AcceptorResponsePayload[]>) => {
      state.list = action.payload;
    },
    setListAcceptorCategories: (state, action: PayloadAction<AcceptorCategoryResponsePayload[]>) => {
      state.listAcceptorCategories = action.payload;
    },
    setAcceptorBranches: (state, action: PayloadAction<AcceptorBranchResponsePayload[]>) => {
      state.acceptorBranches = action.payload;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const acceptors = acceptorsSlice.reducer;
